import { useState, useEffect } from 'react';
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const useGravitonClient = (
  {
    gravitonUrl,
    xGravitonHeaderPublic,
    sleepTime,
  } = { gravitonUrl: '', sleepTime: null },
) => {
  const [client, setClient] = useState(null);

  useEffect(() => {
    const initClient = async () => {
      const link = await (async () => setContext(() => ({
        headers: {
          'x-kap-feds-client-id': xGravitonHeaderPublic,
        },
        uri: gravitonUrl,
      })).concat(new HttpLink()))();

      setClient(
        new ApolloClient({
          cache: new InMemoryCache(),
          link,
        }),
      );
    };

    initClient();
  }, [gravitonUrl, xGravitonHeaderPublic, sleepTime]);

  return { client };
};

export default useGravitonClient;
